/* eslint-disable @nx/enforce-module-boundaries */
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ShellTrackHandlers } from '@cigna/cigna-for-brokers/shared/analytics-util';
import { getAdobeSiteSection } from '@cigna/cigna-for-brokers/shared/util';
import { ContactUsComponent } from '@cigna/cigna-for-brokers/shared/ui';
import { TranslateService } from '@ngx-translate/core';
import { ContactUsDialogService } from '@cigna/cigna-for-brokers/shell/data-access';

@Component({
  selector: 'cigna-caheader-unsecure',
  templateUrl: './header-unsecure.component.html',
  styleUrls: ['./header-unsecure.component.scss'],
})
export class HeaderUnSecureComponent implements OnInit, OnDestroy {
  isSiteDown: boolean;
  contactUsSubscription: Subscription;
  constructor(
    public dialog: MatDialog,
    private analytics: ShellTrackHandlers,
    private router: Router,
    private translate: TranslateService,
    private contactUsDialogService: ContactUsDialogService,
  ) {}

  ngOnInit(): void {
    const siteDown = this.translate.instant(`global.isSiteDown`);
    this.isSiteDown = siteDown === 'true';
  }

  contactUs() {
    this.dialog.open(ContactUsComponent, {
      width: '60rem',
      autoFocus: false,
      disableClose: false,
    });
  }

  isPublicContactUs() {
    return (
      this.router.url.toLowerCase() === '/public/contact-us' ||
      this.router.url.toLowerCase() ===
        '/public/pre-login-contact-us/commercial'
    );
  }

  ngOnDestroy() {
    if (this.contactUsSubscription) {
      this.contactUsSubscription.unsubscribe();
    }
  }
}
